import lottie from 'lottie-web'
import initChooseAgencies from '../util/chooseAgencies';
export default {
  init() {
    lottie.loadAnimation({
      container: document.getElementById('top-animation'), // the dom element that will contain the animation
      renderer: 'svg',
      loop: true,
      autoplay: true,
      path: '/wp-content/themes/ratings/dist/images/animations/top-image.json', // the path to the animation json
    });
    initChooseAgencies();
    $('.choices-dropdown-item-label').on('click', function() {
      const $checkbox = $(this).closest('.choices-dropdown-item').find('.checkbox input').first();
      $checkbox.prop('checked', !$checkbox.prop('checked'));
      $checkbox.trigger('change');
    })
  },
  finalize() {

  },
};



// WEBPACK FOOTER //
// ./scripts/routes/template-front.js